import { render, staticRenderFns } from "./tabs-tab.vue?vue&type=template&id=c9de82b4&scoped=true&"
import script from "./tabs-tab.vue?vue&type=script&lang=js&"
export * from "./tabs-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9de82b4",
  null
  
)

export default component.exports